// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1YLYN","mainHeading":"Header_mainHeading__4CrgE","secondaryHeading":"Header_secondaryHeading__kX76A"};